module.exports = __webpack_public_path__ + "static/Apercu-LightItalic-19b759109f6f6d9deb9ffdb29019f760.eot";